import React from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { FolderKanban } from "lucide-react";

export default function ProjectInfoTab({ project, updateProject }) {
  const set = (key) => (e) =>
    updateProject({ ...project, [key]: e.target.value });

  return (
    <Card data-testid="wizard-project-tab">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <FolderKanban className="h-5 w-5 text-muted-foreground" />
          Project Information
        </CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="proj-name">Project Name *</Label>
          <Input
            id="proj-name"
            data-testid="wizard-project-name"
            value={project.name || ""}
            onChange={set("name")}
            placeholder="e.g., Building A HVAC"
          />
        </div>
        <div>
          <Label htmlFor="proj-number">Project Number</Label>
          <Input
            id="proj-number"
            data-testid="wizard-project-number"
            value={project.number || ""}
            onChange={set("number")}
            placeholder="e.g., P-2026-0042"
          />
        </div>
        <div className="md:col-span-2">
          <Label htmlFor="proj-address">Project Address</Label>
          <Input
            id="proj-address"
            data-testid="wizard-project-address"
            value={project.address || ""}
            onChange={set("address")}
            placeholder="Street, suite, etc."
          />
        </div>
        <div>
          <Label htmlFor="proj-city">City</Label>
          <Input
            id="proj-city"
            data-testid="wizard-project-city"
            value={project.cityText || ""}
            onChange={set("cityText")}
            placeholder="e.g., Boston"
          />
        </div>
        <div>
          <Label htmlFor="proj-state">State / Region</Label>
          <Input
            id="proj-state"
            data-testid="wizard-project-state"
            value={project.state || ""}
            onChange={set("state")}
            placeholder="e.g., MA"
          />
        </div>
      </CardContent>
    </Card>
  );
}
